var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4608 4.36953C25.1735 2.8387 24.3303 1.63081 23.2598 1.21867C21.3037 0.451467 13.478 0.438978 13.478 0.438978C13.478 0.438978 5.65355 0.426489 3.69618 1.15979C2.64693 1.56837 1.78004 2.80302 1.49024 4.33207C0.974359 7.1261 0.969362 12.9211 0.969362 12.9211C0.969362 12.9211 0.964366 18.7447 1.4765 21.5102C1.7638 23.0392 2.60695 24.2471 3.6787 24.6593C5.6548 25.4265 13.4593 25.439 13.4593 25.439C13.4593 25.439 21.285 25.4514 23.2411 24.7199C24.3103 24.3096 25.1573 23.1035 25.4483 21.5744C25.9654 18.7822 25.9692 12.9889 25.9692 12.9889C25.9692 12.9889 25.9942 7.16356 25.4608 4.36953ZM10.9748 18.2897L10.981 7.58463L17.4852 12.9461L10.9748 18.2897Z",
    fill: "#F99F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.fc2adf52250c2531f5234bd9ff3e6b68.svg";
export { ForwardRef as ReactComponent };